var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 0.625,
    width: 39.75,
    height: 39.7501,
    rx: 19.875,
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4116_9536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1559 17.0523C27.0732 19.9727 27.0332 24.6548 24.1735 27.5303C24.1681 27.5362 24.1617 27.5426 24.1559 27.5484L20.8746 30.8297C17.9806 33.7237 13.2721 33.7233 10.3785 30.8297C7.4845 27.9361 7.4845 23.2271 10.3785 20.3336L12.1904 18.5218C12.6708 18.0413 13.4983 18.3606 13.5231 19.0396C13.5547 19.905 13.7099 20.7743 13.9962 21.6139C14.0932 21.8982 14.0239 22.2126 13.8115 22.425L13.1725 23.064C11.804 24.4325 11.7611 26.6607 13.1161 28.0426C14.4844 29.438 16.7336 29.4463 18.1124 28.0675L21.3937 24.7867C22.7702 23.4102 22.7644 21.1853 21.3937 19.8145C21.213 19.6342 21.0309 19.494 20.8887 19.3961C20.7882 19.327 20.7051 19.2354 20.6462 19.1285C20.5873 19.0217 20.5542 18.9025 20.5495 18.7806C20.5302 18.2646 20.713 17.7329 21.1207 17.3252L22.1488 16.2971C22.4183 16.0276 22.8412 15.9945 23.1538 16.2126C23.5118 16.4626 23.8471 16.7436 24.1559 17.0523ZM31.0375 10.1704C28.1439 7.27673 23.4354 7.27634 20.5414 10.1704L17.2601 13.4516C17.2543 13.4575 17.2479 13.4638 17.2426 13.4697C14.3829 16.3453 14.3428 21.0274 17.2601 23.9477C17.5689 24.2565 17.9042 24.5374 18.2621 24.7874C18.5747 25.0055 18.9977 24.9724 19.2672 24.7029L20.2952 23.6748C20.703 23.2671 20.8858 22.7354 20.8664 22.2194C20.8618 22.0975 20.8287 21.9783 20.7698 21.8715C20.7109 21.7646 20.6278 21.673 20.5272 21.6039C20.385 21.506 20.203 21.3658 20.0223 21.1855C18.6515 19.8147 18.6458 17.5898 20.0223 16.2133L23.3035 12.9325C24.6824 11.5537 26.9315 11.562 28.2999 12.9574C29.6549 14.3393 29.612 16.5675 28.2435 17.936L27.6045 18.575C27.3921 18.7874 27.3228 19.1018 27.4198 19.3861C27.7061 20.2257 27.8613 21.095 27.8929 21.9604C27.9177 22.6394 28.7451 22.9587 29.2256 22.4782L31.0374 20.6664C33.9315 17.7729 33.9315 13.0639 31.0375 10.1704Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4116_9536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(8.20801 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoLink);
export default __webpack_public_path__ + "static/media/iconoLink.fee1091c.svg";
export { ForwardRef as ReactComponent };